// Versioned localStorage helpers.
// (Vercel client-localstorage-schema rule: prefix with version + try-catch.)

const SESSION_KEY = 'onlybans:session:v1'

export interface StoredSession {
  token: string
  expiresAt: number
}

export function loadSession(): StoredSession | null {
  try {
    const raw = localStorage.getItem(SESSION_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as StoredSession
    if (typeof parsed?.token !== 'string') return null
    if (parsed.expiresAt <= Date.now()) {
      localStorage.removeItem(SESSION_KEY)
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function saveSession(session: StoredSession): void {
  try {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session))
  } catch {
    /* private mode / quota — no-op */
  }
}

export function clearSession(): void {
  try {
    localStorage.removeItem(SESSION_KEY)
  } catch {
    /* no-op */
  }
}
